var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7857 4.25C11.7857 1.90652 9.86314 0 7.5 0C5.13683 0 3.21429 1.90652 3.21429 4.25H0V14.3438C0 15.8108 1.19923 17 2.67857 17H12.3214C13.8008 17 15 15.8108 15 14.3438V4.25H11.7857ZM7.5 1.59375C8.97696 1.59375 10.1786 2.78534 10.1786 4.25H4.82143C4.82143 2.78534 6.02304 1.59375 7.5 1.59375ZM13.3929 14.3438C13.3929 14.9296 12.9122 15.4062 12.3214 15.4062H2.67857C2.08778 15.4062 1.60714 14.9296 1.60714 14.3438V5.84375H3.21429V7.17188C3.21429 7.61198 3.57405 7.96875 4.01786 7.96875C4.46166 7.96875 4.82143 7.61198 4.82143 7.17188V5.84375H10.1786V7.17188C10.1786 7.61198 10.5383 7.96875 10.9821 7.96875C11.4259 7.96875 11.7857 7.61198 11.7857 7.17188V5.84375H13.3929V14.3438Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.c0cdd4c9.svg";
export { ForwardRef as ReactComponent };